"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackGroundColor = void 0;
var BackGroundColor;
(function (BackGroundColor) {
    BackGroundColor["BLACK"] = "black";
    BackGroundColor["WHITE"] = "white";
})(BackGroundColor = exports.BackGroundColor || (exports.BackGroundColor = {}));
//# sourceMappingURL=ToggleButtonProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/ToggleButton/ToggleButtonProps.js
// module id = 451
// module chunks = 8